var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1839_2699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.809167 9.64448C0.56425 9.64448 0.321356 9.53363 0.161451 9.32401C-0.107756 8.96928 -0.0369122 8.46339 0.319332 8.19532L11.0127 0.163479C11.3022 -0.0521819 11.6989 -0.0541974 11.9883 0.163479L22.6797 8.19532C23.036 8.46339 23.1068 8.96928 22.8376 9.32401C22.5684 9.67875 22.0603 9.74929 21.7041 9.48123L11.5005 1.8162L1.29698 9.48324C1.15124 9.59208 0.979193 9.6465 0.809167 9.6465V9.64448Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2759 20.0003H13.7946C13.3472 20.0003 12.9849 19.6395 12.9849 19.194V15.3222C12.9849 15.296 12.9849 15.2698 12.989 15.2436C12.9971 15.167 12.9971 15.0884 12.989 15.0118C12.9242 14.3669 12.3453 13.8932 11.6956 13.9557C11.0458 14.0202 10.5702 14.5987 10.6349 15.2436C10.637 15.2698 10.639 15.296 10.639 15.3222V19.194C10.639 19.6395 10.2767 20.0003 9.82934 20.0003H3.72664C3.27931 20.0003 2.91699 19.6395 2.91699 19.194V9.03179C2.91699 8.58636 3.27931 8.22559 3.72664 8.22559C4.17397 8.22559 4.53628 8.58636 4.53628 9.03179V18.3878H9.01969V15.3605C8.89218 13.8469 10.0115 12.5025 11.5357 12.3514C13.072 12.2002 14.4484 13.3208 14.6002 14.8526C14.6164 15.0219 14.6184 15.1912 14.6042 15.3605V18.3898H18.4662V9.03381C18.4662 8.58838 18.8285 8.2276 19.2759 8.2276C19.7232 8.2276 20.0855 8.58838 20.0855 9.03381V19.1961C20.0855 19.6415 19.7232 20.0023 19.2759 20.0023V20.0003Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1839_2699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.072c09db3383628f518020573c439e76.svg";
export { ForwardRef as ReactComponent };